var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { defaults } from "../style";
let ReferenceComponent = class ReferenceComponent extends LitElement {
    update(changedProperties) {
        if (changedProperties.has("el")) {
            const oldVal = changedProperties.get("el");
            if (oldVal !== undefined) {
                this.notifyHeap(oldVal[1], "remove");
            }
            this.notifyHeap(this.el[1], "add");
        }
        super.update(changedProperties);
    }
    notifyHeap(target, type) {
        this.dispatchEvent(new CustomEvent(`${type}-reference`, {
            detail: {
                from: this,
                to: target
            },
            bubbles: true,
            composed: true
        }));
    }
    disconnectedCallback() {
        this.notifyHeap(this.el[1], "remove");
    }
    render() {
        return html `<slot></slot>`;
    }
};
ReferenceComponent.styles = [defaults, css `
        :host {
          display: block;
          width: 100%;
          height: 100%;
          min-width: 12px;
          min-height: 14px;
        }
    `];
__decorate([
    property({ type: Array })
], ReferenceComponent.prototype, "el", void 0);
ReferenceComponent = __decorate([
    customElement('tc-reference')
], ReferenceComponent);
export { ReferenceComponent };
//# sourceMappingURL=ReferenceComponent.js.map